"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/pTON/v2_1/constants.ts
var pTON_OP_CODES = {
  TON_TRANSFER: 32736093,
  DEPLOY_WALLET: 1331643155
};



exports.pTON_OP_CODES = pTON_OP_CODES;
//# sourceMappingURL=chunk-V23FVL4P.cjs.map